export default __webpack_public_path__ + "static/media/maestro.ce34c4f0.svg";